import React from 'react';
import { IIconProps } from '../../../interface/interfaces';

const IconComponent: React.FC<IIconProps> = ({ size, iconName }) => {
    return <img 
        style={{ width: `${size}rem` }} 
        src={`/assets/svg/${iconName}.svg`} 
        alt={iconName}
        onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = "/assets/svg/default-icon.svg";
          }}
    />;
};

export default IconComponent;
